<template>
    <div class="row">
        <div class="col-12">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" href="#">Active</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Link</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Link</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link disabled">Disabled</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default
{
    name: 'TabViewer',
    mixins: [
    ],
    components: {

    },
    props: {

    },
    data() {
        return {

        }
    },
    methods: {
    },
}

</script>

<style scoped lang="scss">
</style>